module.exports = __webpack_public_path__ + "img/CTWP__Arrow.14b66e56.png";